// Trefferzahl einer Abfrage ohne ihr Limit (Agent 10B, Runde 10): damit die Leiste „von 5.312“ zeigen kann, wenn „Limit 100“ die Liste kürzt.
// Fragt nur, wenn ein Limit gesetzt ist. Kann die Abfrage-Engine die Abfrage nicht rechnen (alte Close-Abfragen), bleibt die Zahl unbekannt
// und die Leiste zeigt nur das Limit.
import { useEffect, useMemo, useRef, useState } from "react";
import type { Abfrage } from "../../api/filter";
import { listenBerechnungApi } from "../../api/listenBerechnung";

export function useUngekuerzteZahl(abfrage: Abfrage | null, limit: number | null, stempel: string | number): number | null {
  const [zahl, setZahl] = useState<{ key: string; gesamt: number } | null>(null);
  // ohne das Limit selbst: ein anderes Limit ändert die Gesamtzahl nicht
  const key = useMemo(() => (abfrage && limit !== null ? JSON.stringify([abfrage.query, stempel]) : null), [abfrage, limit, stempel]);
  const abfrageRef = useRef(abfrage);
  abfrageRef.current = abfrage;

  useEffect(() => {
    if (!key) return;
    let weg = false;
    const t = window.setTimeout(() => {
      const a = abfrageRef.current;
      if (!a) return;
      listenBerechnungApi
        .anzahlOhneLimit({ ...a, results_limit: null } as Abfrage)
        .then((r) => !weg && setZahl({ key, gesamt: r.gesamt }))
        .catch(() => !weg && setZahl(null));
    }, 150);
    return () => {
      weg = true;
      window.clearTimeout(t);
    };
  }, [key]);

  return key && zahl && zahl.key === key ? zahl.gesamt : null;
}
